import PropTypes from 'prop-types';
import React from 'react';
import ActionButton from '../../components/ActionButton';
import ActionLink from '../../components/ActionLink';
import EditableDataTableExt from '../../components/EditableDataTableExt';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import SimpleReactValidator from '../../components/validator';
import FileUploadService from '../../services/FileUploadService';

class QuestionComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modifiedList: new Map(),
            addedList: [],
        };
        this.fileUploadService = new FileUploadService();
    }

    render() {
        const {idPrefix, t} = this.props;

        const answerColumns = [];
        answerColumns.push({
            field: 'text',
            header: t('quiz.quizAnswerText'),
            editor: 'TEXT',
            validators: 'required',
        });
        if (this.props.renderAnswerCorrectColumn) {
            answerColumns.push({
                field: 'correct',
                header: t('quiz.correct'),
                editor: 'CHECKBOX',
                validators: 'not_required',
            });
        }
        if(this.props.relatedWithAction){
            answerColumns.push({
                field: 'fileUuid',
                header: t('quiz.image'),
                editor: 'IMAGE',
                validators: 'not_required',
            });
        }
        return (
            <div className='question-div' style={{marginBottom: '3px'}}>
                <div className='row'>
                    <div className='col-12'>
                        <div className='p-card-header-minheight' style={{marginBottom: '25px'}}>
                            <div className='header-item-right'>
                                <ActionButton
                                    label={t('quiz.deleteQuestion')}
                                    className='float-right'
                                    key={'next-button'}
                                    handleClick={(e) => this.props.handleRemoveQuestion(e, idPrefix)}
                                    iconName='mdi-delete'
                                    iconSide='left'
                                    iconSize='m'
                                    rendered={!this.props.relatedWithAction && this.props.viewMode !== 'VIEW'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xl-6 col-lg-12'>
                        <InputTextComponent
                            id={`${idPrefix}questionName`}
                            name='question'
                            label={t('quiz.quiestionName')}
                            value={this.props.element?.question}
                            stateField={this.props.stateField}
                            onChange={this.props.handleChange}
                            colClass='col-md-12'
                            viewMode={this.props.viewMode}
                            validator={this.props.validator}
                            validators='required|max:160'
                            disabled={this.props.disabled}
                            validateViewMode
                            placeholder={t('quiz.questionPlaceholder')}
                        />
                        <InputNumberComponent
                            id='coinsToEarn'
                            name='coinsToEarn'
                            label={t('quiz.coinsToEarn')}
                            colClass='col-md-12'
                            value={this.props.element.coinsToEarn}
                            validator={this.props.validator}
                            onChange={this.props.handleChange}
                            viewMode={this.props.viewMode}
                            stateField={this.props.stateField}
                            onAfterStateChange={() =>
                                this.props.onAfterCoinEdition(this.props.element.coinsToEarn, this.props.element.order)
                            }
                            rendered={this.props.renderCoinsToEarn}
                        />

                        {this.props.renderPhoto ? (
                            this.props.element?.headerPhoto ? (
                                <div className='editable-photo-div'>
                                    <img
                                        src={this.props.headerPhotoUrl}
                                        alt='Quiz icon'
                                        className='product-image'
                                        style={{height: '150px', width: 'auto'}}
                                    />
                                    {this.props.viewMode !== 'VIEW' ? (
                                        <ActionLink
                                            className='p-link float-right'
                                            handleClick={(e) => this.props.handleRemoveAttachment(e, this.props.element.order)}
                                            variant='red'
                                            iconName='mdi-trash-can'
                                            iconSide='left'
                                            iconSize='xs'
                                            iconColor='red'
                                        />
                                    ) : null}
                                </div>
                            ) : (
                                <>
                                    {this.props.tempUrl && (
                                        <div>
                                            <img
                                                src={this.props.tempUrl}
                                                alt='Quiz icon'
                                                className='product-image'
                                                style={{height: '150px', width: 'auto'}}
                                            />
                                            <ActionLink
                                                className='p-link float-right'
                                                handleClick={(e) => this.props.handleRemoveTempFileQuestion(e, this.props.element.order)}
                                                variant='red'
                                                iconName='mdi-trash-can'
                                                iconSide='left'
                                                iconSize='xs'
                                                iconColor='red'
                                            />
                                        </div>
                                    )}
                                    {this.props.viewMode !== 'VIEW' && (
                                        <label class='custom-file-upload'>
                                            <input
                                                type='file'
                                                id='avatar'
                                                name='avatar'
                                                onChange={(e) => this.onSelect(e.target)}
                                                accept='image/*'
                                            />
                                            {t('file.choose')}
                                        </label>
                                    )}
                                </>
                            )
                        ) : null}
                    </div>
                    <div className='col-xl-6 col-lg-12' >
                        <EditableDataTableExt
                            locale={this.props.locale}
                            id={`${idPrefix}answerOptions`}
                            name='answerOptions'
                            label={t('quiz.quizAnswers')}
                            showLabel={true}
                            imageSrcFnc={(rowData)=>{
                                return this.props.imageSrcFnc(rowData);
                            }}
                            columns={answerColumns}         
                            addedListName='addedList'
                            addedList={this.state.addedList}
                            modifiedListName='modifiedList'
                            modifiedList={this.state.modifiedList}
                            validator={this.props.validator}
                            viewMode={this.props.viewMode}
                            onChange={this.props.handleChange}
                            editable ={!this.props.relatedWithAction}
                            showAddButton={!this.props.relatedWithAction && this.props.viewMode !== 'VIEW'}
                            showDeleteButton={!this.props.relatedWithAction && this.props.viewMode !== 'VIEW'}
                            addButtonLabel={t('quiz.addAnswer')}
                            stateField={this.props.stateField}
                            dataKey='uuid'
                            updateItemElementAfterEdit={this.updateItemElementAfterEdit}
                            ref={this.editableListRef}
                            className='answer-area-table'
                            tableClassName='answer-options-table'
                            value={this.props.element.answerOptions}
                            addButtonDisabled={!!(this.props.element?.answerOptions?.length >= 10)}
                            validators='array_required'
                            permanentDelete
                            handleAddElement={() => this.props.createNewAnswerOption(this.props.element.order)}
                            handleRemoveElement={(rowData) => this.props.removeAnswerOption(this.props.element.order, rowData.order)}
                            onAfterEditElement={(rowData, event) =>
                                this.props.onAfterEditAnswerOptions(rowData, event, this.props.element.order)
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
    onSelect = (e) => {
        if(e.files[0].size < this.props.imgMaxSizeParameter) {
            this.setState(
                {
                    selectedFile: e.files[0],
                },
                () => {
                    this.uploadHandler();
                }
            );
        }
        else {
            this.props.onErrorMessage(this.props.invalidFileSizeMessageDetail)
            }

    };

    onClear = () => {
        this.setState({
            selectedFile: undefined,
        });
    };

    uploadHandler = async () => {
        const selectedFile = this.state.selectedFile;
        const formData = new FormData();
        formData.append('file', selectedFile);
        this.fileUploadService.uploadAttachemnt(formData).then((uploadedFile) => {
            this.props.setAttachmentForQuestion(this.props.element.order, uploadedFile);
        });
    };
}

QuestionComponent.defaultProps = {
    element: null,
    imageSrcFnc: null,
    idPrefix: '',
    viewMode: 'VIEW',
    stateField: 'element',
    colClass: 'col-md-4',
    disabled: false,
    renderCoinsToEarn: true,
    renderPhoto: true,
    renderAnswerCorrectColumn: true,
    relatedWithAction: false,
};

QuestionComponent.propTypes = {
    element: PropTypes.object,
    answerTypeOptions: PropTypes.array,
    idPrefix: PropTypes.string,
    stateField: PropTypes.string,
    viewMode: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    onErrorMessage: PropTypes.func.isRequired,
    imageSrcFnc: PropTypes.func,
    validator: PropTypes.instanceOf(SimpleReactValidator).isRequired,
    handleRemoveQuestion: PropTypes.func.isRequired,
    renderCoinsToEarn: PropTypes.bool,
    renderPhoto: PropTypes.bool,
    renderAnswerCorrectColumn: PropTypes.bool,
    relatedWithAction: PropTypes.bool,
};

export default QuestionComponent;
